import * as React from "react";
import {useEffect, useState} from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import "./styles.scss";
import ContainerBox from "myshubhlife-component/container-box";
import {COLOR} from "utils/variables";
import {routePaths, indexPath} from "loan-application/routes";
import {IApplicationFields, ILoanProducts} from "loan-application/interface";
import {clearApplicationFields, selectedLoanProduct} from "loan-application/actions";
import {AndroidApis} from "app";
import BasicCard from "myshubhlife-component/card";
import {imageBaseUrl} from "config";
import Loading from "components/loading";
import { defaultErrorMessage } from "loan-application/utils";
import {IProfile} from "profile/interface";
import {EventName, updateProductViewEvent, updateEligibilityEvents} from "loan-application/event";
import {getLoanProducts} from "loan-application/apiCall";
import ImageCarousel from "loan-application/ImageCarousel";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    isAndroid: boolean;
    profileInfo: IProfile;
    applicationFields: IApplicationFields;
}

const getProducts = (productList: ILoanProducts[]) => {
    const preApprovedList = productList.filter((value) => value.preApproved);
    return preApprovedList.length ? preApprovedList : productList;
};

const LoanProducts = (props: IConnectProps & RouteComponentProps) => {
    const [loading, setLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);
    const [products, setProducts] = useState<ILoanProducts[]>([]);
    const [kypItem, setKypItem] = useState<ILoanProducts>(null);
    const [kypDisplayed, setKypDisplayed] = useState<string[]>(JSON.parse(localStorage.getItem("KypViewedItem")) || []);
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.isAndroid) {
            AndroidApis.toolBarConfig({visibility: true, title: "Products"});
        }
        if (props.applicationFields) {
            props.dispatch(clearApplicationFields());
        }
        (async () => {
            setLoading(true);
            try {
                const response = await getLoanProducts();
                setProducts(getProducts(response.product_specs));
                setKypItem(
                    getProducts(response.product_specs)
                    .find((p) => (p.kypImages && p.kypImages.length > 0) && !kypDisplayed.includes(p.productType))
                );
            } catch (e) {
                setErrorMsg("Something went wrong!");
            }
            setLoading(false);
        })();
    }, []);
    useEffect(() => {
        setKypItem(products.find((p) => (p.kypImages && p.kypImages.length > 0) && !kypDisplayed.includes(p.productType)));
    }, [kypDisplayed])
    const handleClick = (product: ILoanProducts) => {
        updateProductViewEvent(product);
        props.dispatch(selectedLoanProduct(product.productType));
        props.history.push({pathname: `${indexPath}${routePaths.APPLICATION}`});
    };
    useEffect(() => {
        if (props.profileInfo && props.profileInfo.financeBasicInfo) {
        }
    }, [props.profileInfo]);

    const onKypClose = (product: string) => {
		if (!kypDisplayed.includes(product)) {
			localStorage.setItem("KypViewedItem", JSON.stringify([...kypDisplayed, product]));
		}
        setKypDisplayed((i) => [...i, product]);
    }
    const handleKypDetails = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, productType: string) => {
        const restItem = kypDisplayed.filter((product) => productType !== product);
        setKypDisplayed(restItem);
    };
    return (
        <ContainerBox pageTitle={!props.isAndroid ? "Products" : ""} showBackButton={!props.isAndroid}
            backgroundColor={COLOR.LIGHT_BG}
        >
            <Loading active={loading} />
            {errorMsg && defaultErrorMessage(errorMsg)}
            {kypItem &&
                <ImageCarousel fieldName={kypItem.productType} imagesList={kypItem.kypImages} onClose={onKypClose}/>}
            {
                products.length > 0 && !errorMsg &&
                    <div className="product-container">
                        <div className="loan-card">
                            <div>
                                <h1 className="loan-title">Loans</h1>
                                <p className="loan-description">
                                    Get collateral free, quick and simple loans for all your
                                     needs starting from Rs.3,500 to 4 lacs.
                                </p>
                            </div>
                        </div>
                        {products.length > 0 && products.map((product, index) => {
                            return(
                                <React.Fragment key={index}>
                                    <div className="loan-product-card">
                                        <div className="loan-card clickable"
                                             onClick={() => handleClick(product)}
                                        >
                                            <div>
                                                <div className="loan-desc-flex">
                                                    <h5 className="title">{product.title}</h5>
                                                </div>
                                                <p className="desc">{product.description}</p>
                                            </div>
                                            <div className="card-right">
                                                <span className="arrow-icon">&#8250;</span>
                                            </div>
                                        </div>
                                        {
                                            product.kypImages && product.kypImages.length > 0 &&
                                            <div className="details-text"
                                                 onClick={(e) => handleKypDetails(e, product.productType)}>
                                                Click here to view details
                                            </div>
                                        }
                                    </div>
                                </React.Fragment>
                            );
                        })}
                    </div>
            }
            {
                !products.length && !errorMsg && !loading &&
                <BasicCard>
                    <div className="not-eligible-container">
                        <img src={`${imageBaseUrl}/img/icons/not-eligible-error.png`}
                             width={100}
                             alt="icon"
                        />
                        <h4 style={{color: COLOR.PRIMARY}}>Not Eligible!</h4>
                            <p>Sorry! You are <b>Not Eligible</b> for a loan currently.&nbsp;
                            {
                                props.isAndroid ?
                                 "However you can still explore our other products." :
                                 ""
                            }
                            </p>
                    </div>
                </BasicCard>
            }
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        profileInfo: state.profileInfo.profile,
        isAndroid: state.login.isAndroid,
        applicationFields: state.loanApplication.applicationFields,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(LoanProducts);
